(() => {
  const els = document.querySelectorAll('.collection-pills');
  els.forEach(el => {
    let isDown = false;
    let startX = 0;
    let startLeft = 0;

    const onDown = (e) => {
      isDown = true;
      startX = e.clientX || (e.touches && e.touches[0].clientX) || 0;
      startLeft = el.scrollLeft;
      el.style.cursor = 'grabbing';
      el.classList.add('is-dragging');
      // với Pointer Events:
      if (e.pointerId && el.setPointerCapture) el.setPointerCapture(e.pointerId);
    };

    const onMove = (e) => {
      if (!isDown) return;
      const x = e.clientX || (e.touches && e.touches[0].clientX) || 0;
      el.scrollLeft = startLeft - (x - startX);
    };

    const onUp = () => {
      isDown = false;
      el.style.cursor = 'grab';
      el.classList.remove('is-dragging');
    };

    // Desktop + iOS/Android
    el.addEventListener('pointerdown', onDown);
    el.addEventListener('pointermove', onMove);
    el.addEventListener('pointerup', onUp);
    el.addEventListener('pointercancel', onUp);
    el.addEventListener('pointerleave', onUp);

    // Fallback cho iOS cũ
    el.addEventListener('touchstart', onDown, {passive: true});
    el.addEventListener('touchmove', onMove, {passive: true});
    el.addEventListener('touchend', onUp);
  });
})();
